import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';
import { FormattedMessage } from 'react-intl';
import { ListItem, Divider } from 'material-ui';
import { map, isEmpty } from 'lodash';

import { dateTime } from 'utils/dateTools';
import { shouldUse } from 'utils/valuesByKey';
import { getAttendeeMsg } from 'utils/helpers';
import KFlatButton from 'components/KJRN/KFlatButton';
import TLoading from './TLoading';
import TMessage from './TMessage';
import styles from './styles/TEvents';

const TEvents = () => {
  const dispatch = useDispatch();
  const { coursesReducer, WebValuesReducer, loginReducer } = useSelector(state => state);
  const { allCourses, coursesLoaded, error } = coursesReducer;
  const { valuesByKey } = WebValuesReducer;
  const { user: { Gender, EmployeeMasterID } } = loginReducer;

  const useEvents = shouldUse(valuesByKey, 'Events');

  if (!coursesLoaded) {
    return <TLoading />;
  }

  if (error) {
    return <TMessage type="error" message={useEvents ? 'tile.events.error' : 'tile.courses.error'} />;
  }

  if (isEmpty(allCourses)) {
    return <TMessage message={useEvents ? 'tile.events.empty' : 'tile.courses.empty'} />;
  }

  const renderCourseRow = course => (
    <div key={course.CourseID}>
      <ListItem
        innerDivStyle={styles.course}
        hoverColor="transparent"
        primaryText={course.CourseName}
        secondaryText={
          <div style={styles.secondary}>
            {dateTime(course.CourseBegda)}
            {course.Attending && <div style={styles.tag}>{getAttendeeMsg(course.CourseAttendees, EmployeeMasterID, Gender)}</div>}
          </div>
        }
        onClick={() => dispatch(push({
          pathname: `/events/${course.CourseID}`,
          query: { dashboard: true },
        }))}
      />
      <Divider />
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={{ maxHeight: 422, overflow: 'auto', height: '100%' }}>
        {map(allCourses, renderCourseRow)}
      </div>
      <KFlatButton
        style={styles.actionButton}
        onClick={() => dispatch(push('/events'))}
        containerStyle={styles.action}
        label={<FormattedMessage id={useEvents ? 'tile.events.goto' : 'tile.courses.goto'} />}
      />
    </div>
  );
};

export default TEvents;



// WEBPACK FOOTER //
// ./src/containers/tiles/TEvents.js